class coresServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/cores/:route',{},{
			getCores:{
				method:'GET',
				params : {}
			},
			getCoreDetails:{
				method:'GET',
				params : {
					route: 'id'
				}
			},
			saveCores:{
				method:'POST',
				params : {}
			},
			updateCores:{
				method:'PUT',
				params : {}
			},

		});

		return {
			services : services
		};
	}
}

coresServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.coresServices', [])
.service('coresServices', coresServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/cores/coresServices.js